import {RouterView} from '@/routes/RouterView.js';

const PersonalData = _ => import(/* webpackChunkName: "js/split/AdvisorPersonalData", webpackPreload: true */	'@/components/views/home/advisor/PersonalData');

const Documents = _ => import(/* webpackChunkName: "js/split/AdvisorDocuments", webpackPreload: true */	'@/components/views/home/advisor/Documents');
const Places = _ => import(/* webpackChunkName: "js/split/AdvisorPlaces", webpackPreload: true */	'@/components/views/home/advisor/Places');
const AddPlace = _ => import(/* webpackChunkName: "js/split/AdvisorAddPlace", webpackPreload: true */	'@/components/views/home/advisor/AddPlace');
const TrainingPlans = _ => import(/* webpackChunkName: "js/split/AdvisorTrainingPlans", webpackPreload: true */	'@/components/views/home/advisor/sectionFourth/TrainingPlans');
const AddTrainingPlan = _ => import(/* webpackChunkName: "js/split/AdvisorAddTrainingPlan", webpackPreload: true */	'@/components/views/home/advisor/sectionFourth/AddTrainingPlan.vue');

const WorkCenterIndex = _ => import(/* webpackChunkName: "js/split/WorkCenterIndex", webpackPreload: true */ '@/components/views/home/advisor/workcenters/Index');
const WorkCenterForm = _ => import(/* webpackChunkName: "js/split/WorkCenterForm", webpackPreload: true */ '@/components/views/home/advisor/workcenters/Form');
const CompleteRegister = _ => import(/* webpackChunkName: "js/split/CompleteRegister", webpackPreload: true */ '@/components/views/home/advisor/sectionThird/CompleteRegister');

export default {
	path: '/perfilTutores',
	component: RouterView,
	children: [
		{
			path: 'paso1',
			component:  PersonalData,
			name: 'PersonalData',
			meta:{
				auth: true
			}
		},
		{

			path: 'paso2',
			component:  Documents,
			name: 'Documents',
			meta:{
				auth: true
			}
		},
		{
			path: 'paso3',
			component:  Places,
			name: 'step3',
			meta:{
				auth: true
			}
		},
		{
			path: 'paso3/nuevo',
			component:  AddPlace,
			name: 'stepNew3',
			meta:{
				auth: true
			}
		},
		{
			path: 'paso4',
			component:  TrainingPlans,
			name: 'step4',
			meta:{
				auth: true
			}
		},
		{
			path: 'paso4/nuevo',
			component:  AddTrainingPlan,
			name: 'stepNew4',
			meta:{
				auth: true
			}
		},
		{
			path: 'paso4/editar/:id',
			component:  AddTrainingPlan,
			name: 'stepNewEdit4',
			props: true,
			meta:{
				auth: true
			}
		},
		{
			path: 'paso5',
			component: CompleteRegister,
			name: 'step5',
			meta: {
				auth: true
			}
		},
		{
			path: 'centros-de-trabajo',
			component:RouterView,
			meta:{
				auth:true
			},
			children:[
				{
					path:'',
					component:WorkCenterIndex,
					meta:{
						auth:true
					}	
				},
				{
				path:'nuevo',
				component: WorkCenterForm,
				meta:{
					auth:true
				}
				},
				{
					path:':id/editar',
					component: WorkCenterForm,
					meta:{
						auth:true
					}
					}
			]
		}
	],

}
